import ButtonComponent from "../../components/ButtonComponent"
import { buttonConfig, fontSize_detail25, fontSize_headerTitles, maxWidth } from "../../shared/styleconfig"
import { useNavigate } from "react-router-dom";

export const ContentImageComponent = ({
    subTitle, 
    mainTitle, 
    desc, 
    hasButton, 
    contentImage, 
    imageIsOnRight = false, 
    hasPadding = true, 
    isLastSection =false,
    ismultiparagraph = false,
    paragraphs=[],
    removeMaxWidth = false
}) => {
    const navigate = useNavigate();
    const mainDivCss = `w-[80%] ${maxWidth} mx-auto font-[Helvetica LT Std] grid mg:grid-cols-1 lg:grid-cols-2 gap-10 ${isLastSection ? 'lg:mt-12 lg:mb-0 xs:my-12' : ' lg:my-12 xs:my-12'}`
    const subDivCss = `flex flex-1 flex-col justify-center items-center ${imageIsOnRight ? 'lg:pl-[80px]' : 'lg:pl-0'}`
    const descTitle = `xl:text-[16px] lg:text-[16px] md:text-[2vw]  sm:text-[3vw] xs:text-[3vw] font-bold text-[#0061FC] uppercase xl:pb-[20px] lg:pb-[10px] pb-[20px]`
    const mainTitleCss = `xl:text-[30px] xl:leading-[32px] lg:text-[30px] lg:leading-[32px] md:text-[3.25vw] md:leading-[3.25vw] sm:text-[4.25vw] sm:leading-[5vw] xs:text-[4.25vw] xs:leading-[5.5vw] font-bold text-black max-w-[552px] xl:pb-[20px] lg:pb-[10px] pb-[20px]`
    const descCss = `${fontSize_detail25}  font-normal text-[#707070] max-w-[603px]`
    const imageDiv = `flex flex-1`
    const buttonCss = `bg-[#1a60de] border-[#1a60de] font-bold text-white mt-4 mb-2`
    return (
        <div className={mainDivCss}>
            {!imageIsOnRight && 
            <div className={imageDiv}>
                <img src={contentImage} className={`object-contain ${!removeMaxWidth ? 'lg:max-w-[500px]': ''}`} />
            </div>}
            <div className={subDivCss}>
                <div>
                    {subTitle !== '' && <p className={descTitle}>{subTitle}</p>}
                    <p className={mainTitleCss}>{
                        typeof mainTitle === 'string' ? mainTitle : mainTitle.map((title) => <p>{title}</p>)
                    }</p>
                    {
                        ismultiparagraph ? 
                        paragraphs?.map((paragraph,i ) => {
                            return (
                                <p className={descCss} key={i} >{paragraph}</p>
                            )
                        })
                        : <p className={descCss}>{desc}</p>
                    }
                    
                    {hasButton && <ButtonComponent 
                        buttontext="Join Beta"
                        className={`border-[#707070] bg-[#1a60de] font-bold text-white`}
                        onClick={() => navigate("/auth/signup")}
                    />}
                </div>
            </div>
            {imageIsOnRight && 
            <div className={`${imageDiv} justify-end`}>
                <img src={contentImage} className={`object-contain ${!removeMaxWidth ? 'lg:max-w-[500px]': ''}`} />
            </div>}
        </div>
    );
}